// src/models/orcamentos/Orcamento.js
export const SITUACOES_ORCAMENTO = { 1: 'Aberto', 2: 'Aprovado', 3: 'Reprovado' };

export class Orcamento {
  constructor(filialId = 0, usuarioId = 0) {
    Object.assign(this, {
      id: 0,
      filialId,
      numero: 0,
      clienteId: 0,
      clienteNome: '',
      clienteTelefone: '',
      equipamentoClienteId: null,
      equipamentoDescricao: '',
      problemaRelatado: '',
      observacao: '',
      validadeDias: 15,
      situacao: 1,
      valorProdutos: 0,
      valorServicos: 0,
      valorDesconto: 0,
      valorTotal: 0,
      usuarioId,
      itens: [],
      historicos: [],
    });
  }
}

export const moedaOrcamento = valor => Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const dataHoraOrcamento = valor => (valor ? new Date(valor).toLocaleString('pt-BR') : '-');
